import { render, staticRenderFns } from "./GpAccordion.vue?vue&type=template&id=635ec413&scoped=true&"
import script from "./GpAccordion.vue?vue&type=script&lang=js&"
export * from "./GpAccordion.vue?vue&type=script&lang=js&"
import style0 from "./GpAccordion.vue?vue&type=style&index=0&id=635ec413&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635ec413",
  null
  
)

export default component.exports